class LatencyUI
{

	static DefaultLatency = 3;

	static LatencyLevels = [
		{
			Name: "Excellent",
			MinPing: 0,
			MaxPing: 50,
			Icon: "fa-duotone fa-solid fa-signal-bars",
			Classes: ["text-green-500"],
		},
		{
			Name: "Good",
			MinPing: 51,
			MaxPing: 80,
			Icon: "fa-duotone fa-solid fa-signal-bars-good",
			Classes: ["text-green-700"],
		},
		{
			Name: "Fair",
			MinPing: 81,
			MaxPing: 140,
			Icon: "fa-duotone fa-solid fa-signal-bars-fair",
			Classes: ["text-orange-500"],
		},
		{
			Name: "Poor",
			MinPing: 141,
			MaxPing: Number.POSITIVE_INFINITY,
			Icon: "fa-duotone fa-solid fa-signal-bars-weak",
			Classes: ["text-red-500"],
		}
	]

	static updateUIElements()
	{
		let elems = document.querySelectorAll("[data-latency-ui]");

		elems.forEach(elem => {

			var dcID = elem.getAttribute("data-latency-dc-id");

			if(!dcID) {
				return;
			}

			let ping = LatencyManager.getPing(dcID);
			let hasPing = LatencyManager.hasPing(dcID);

			this.updateUIElement(elem, dcID, ping, hasPing);

		});

	}

	static onDatacentrePingUpdate(id, ping)
	{
		//Find any elements that are listening to this datacentre.
		let elems = document.querySelectorAll(`[data-latency-dc-id="${id}"]`);

		elems.forEach(elem => {
			this.updateUIElement(elem, id, ping, true);
		})

	}

	static calculateLatencyLevel(ping)
	{
		return this.LatencyLevels.find(level =>
			ping >= level.MinPing && ping <= level.MaxPing
		) ?? this.LatencyLevels[this.LatencyLevels.length - 1];

	}

	static updateUIElement(elem, id, ping, hasPing)
	{
		let level = this.calculateLatencyLevel(ping);

		let classes = level.Classes;

		if(hasPing === false) {
			elem.innerHTML = `
				<div class="flex gap-2 items-center text-gray-500">
					<i class="fa-duotone fa-solid fa-signal-bars fa-fw fa-lg"></i>
					—
				</div>
			`;
			return;
		}

		elem.innerHTML = `
			<div class="${['flex gap-2 items-center', ...classes].join(' ')}">
				<i class="${level.Icon} fa-fw fa-lg"></i>
				<div class="font-bold">${ping}</div>
			</div>
		`;

	}

}

window.LatencyUI = LatencyUI;
